<template>
  <div class="live-list-small-wrapper" data-live-list-small-wrapper>
    <ul class="live-list-small">
       <template v-for='item in items'>
          <slider-item v-if='itemIsCanceled(item)' :item='item' :key=item.id></slider-item>
          <slider-item-link v-else-if='itemHasLink(item)' :item='item' :key=item.id></slider-item-link>
          <slider-item v-else :item='item' :key=item.id></slider-item>
       </template> 
    </ul>
  </div>
</template>

<script>
import consts from '../../consts'
import mixins from '../../mixins'
import SliderItem from './SliderItem'
import SliderItemLink from './SliderItemLink'

export default {
  mixins: [mixins],
  name: 'slider-content',
  data () {
    return {
      items: this.liveHelper().sliderItems(this.$root.cmsData, this.$root.liveData)
    }
  },
  components: {
    SliderItem,
    SliderItemLink
  },
  methods: {
    itemHasLink: function (item) {
      return item.videoLink && item.videoLink.length > 0
    },
    itemIsCanceled: function (item) {
      return item.status === consts.status.canceled
    }
  }
}
</script>



// WEBPACK FOOTER //
// SliderContent.vue?18905f5f